import { DRIVETIME } from 'constants/routes';
import { serviceRoles } from 'config/access';
import { checkAccess } from 'helpers/auth';
import DrivetimePage from './container/DrivetimePage';

export default function getSettingsRoute(userAuth) {
  const { account, reports } = serviceRoles;
  const requireAuth = {
    [account.name]: [
      account.roles.superadmin,
    ],
    [reports.name]: [
      reports.roles.reporter,
    ],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: DRIVETIME,
    withSidebar: true,
    withAppBar: true,
    component: DrivetimePage,
  };
}
